<div class="topline">
    <h1>Agency</h1>

    <mat-form-field *ngIf="agencies.length > 0" appearance="outline">
        <mat-label>Current Agency</mat-label>
        <mat-select
                [(value)]="selectedAgencyId"
                (selectionChange)="setAgencyId($event.value)">
            <mat-option *ngFor="let agency of agencies" [value]="agency.id">
                {{ agency.name }} ({{ agencyClientCounts[agency.id] || 0 }})
            </mat-option>
        </mat-select>
    </mat-form-field>

    <h1 *ngIf="agencies.length === 0">
        {{ agencyName }}
    </h1>
</div>

<app-infoband [items]="info"></app-infoband>

<nav mat-tab-nav-bar [tabPanel]="tabs">
    <a
            mat-tab-link
            *ngFor="let link of links"
            (click)="gotoTab(link)"
            [active]="activeLink?.title === link.title">
        {{ link.title }}
    </a>
</nav>

<!-- No agency selected -->
<ng-container *ngIf="!selectedAgencyId">
    <app-inlinemessage
            level="info"
            message="Please select an agency so that you can update their profile, members, and producers">
    </app-inlinemessage>
</ng-container>

<!-- Agency selected -->
<ng-container *ngIf="selectedAgencyId">
    <app-agency-profile
            *ngIf="activeLink?.title === 'Profile'"
            [companyId]="selectedAgencyId">
    </app-agency-profile>

    <app-agency-clients
            *ngIf="activeLink?.title === 'Clients'"
            [companyId]="selectedAgencyId"
            [enabled]="true"
            (countEvent)="setCount('Clients', $event)">
    </app-agency-clients>

    <app-agency-members
            *ngIf="activeLink?.title === 'Members'"
            [companyId]="selectedAgencyId"
            [enabled]="true"
            (countEvent)="setCount('Members', $event)">
    </app-agency-members>

    <app-agency-producers
            *ngIf="activeLink?.title === 'Producers'"
            [companyId]="selectedAgencyId"
            [enabled]="true"
            (countEvent)="setCount('Producers', $event)">
    </app-agency-producers>
</ng-container>

<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
